// TODO: Move to DB
const PermissionGate = ({ permissionType, requiredPermissions, children }) => {
  const userDetail = JSON.parse(localStorage.getItem("userDetail"));
  if (!userDetail || !userDetail.access) return children;
  // console.log(permissionType, requiredPermissions, userDetail.access);
  const hasPermission = requiredPermissions.every((perm) =>
    userDetail.access[permissionType]?.includes(perm)
  );
// console.log(hasPermission)
  return hasPermission ? children : null;
};

export default PermissionGate;
